/**
 * 返回 json 字符串解析后的对象
 * @param {string|null} val
 */
export default function JSONParse(val) {
  let temp = null
  if (typeof val === 'string') {
    try {
      temp = JSON.parse(val)
    } catch (e) {
      console.warn(e)
    }
  }

  return temp
}
